import { createStateReducer } from "../../utils/createStateReducer";
import { initialState } from "./initialState";
import { propagateEvent } from "./propagateEvent";

const reduceOptimizedGantt = createStateReducer(
  initialState,
  {},
  propagateEvent,
);

export { reduceOptimizedGantt };
